import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-chat-box-detail',
    templateUrl: './chat-box-detail.component.html',
    styleUrls: ['./chat-box-detail.component.scss'],
    standalone: false
})
export class ChatBoxDetailComponent {
  constructor(private route: ActivatedRoute) {}
  
  ngOnInit() {
    this.route.params.subscribe(params => {
      const messageId = params['messageId'];
      // Use the messageId to fetch and display the corresponding message
    });
  }

}
